const storageKeys = {
  token: "t",
  tokenExpiretime: "tet",
  refreshToken: "rt",
  theme: "thm",
  user: "u",
  menus: "m"
};
export default storageKeys;
